<script lang="ts">
  import { router } from '$lib/router';
  import UnitCanvas from './canvas/UnitCanvas.svelte';
  import ZoneCanvas from './canvas/ZoneCanvas.svelte';
  import RoomCanvas from './canvas/RoomCanvas.svelte';
  import LoadCanvas from './canvas/LoadCanvas.svelte';
  import RcuCanvas from './canvas/RcuCanvas.svelte';
  import KeypadCanvas from './canvas/KeypadCanvas.svelte';
  import SceneCanvas from './canvas/SceneCanvas.svelte';
  import BrowseLoadsCanvas from './canvas/BrowseLoadsCanvas.svelte';
  import LedLogicDeviceCanvas from './canvas/LedLogicDeviceCanvas.svelte';
  import ProductsCanvas from './canvas/ProductsCanvas.svelte';

  let entity = $derived(router.selectedEntity);
</script>

{#if !entity.type}
  <UnitCanvas />
{:else if entity.type === 'browse-loads'}
  <BrowseLoadsCanvas />
{:else if entity.type === 'led-logic' && entity.id}
  <LedLogicDeviceCanvas id={entity.id} />
{:else if entity.type === 'products'}
  <ProductsCanvas />
{:else if entity.type === 'zone'}
  <ZoneCanvas id={entity.id!} />
{:else if entity.type === 'room'}
  <RoomCanvas id={entity.id!} />
{:else if entity.type === 'load'}
  <LoadCanvas id={entity.id!} />
{:else if entity.type === 'rcu' || entity.type === 'din'}
  <RcuCanvas type={entity.type} id={entity.id!} />
{:else if entity.type === 'keypad'}
  <KeypadCanvas id={entity.id!} />
{:else if entity.type === 'scene'}
  <SceneCanvas id={entity.id!} />
{:else}
  <div class="p-3 text-sm text-text-muted">
    Canvas: {entity.type} / {entity.id}
  </div>
{/if}
